export { default } from './ButtonBase';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ButtonBase/index.js
// module id = 97
// module chunks = 121